<template>
    <div class="military-content">
        <FightContent v-if="actionTrack=='match_chinese_weapon'" :eWidth="430" :eHight="150"  :technicalDetails="technicalDetails"/>
        <GradeContent v-else-if="technicalDetails&&actionTrack=='match_taekwondo_score_rounds,match_vs_score_log'" :technicalDetails="technicalDetails"/>
        <!-- 举旗 -->
        <template v-else-if="technicalDetails&&actionTrack=='match_taekwondo_sample_rounds,match_taekwondo_sample'&&!isDetail">
            <SampleContent  :technicalDetails="technicalDetails" :scoreDetail="technicalDetails"/>
        </template>
        <template v-else>
            <SampContentDetail :scoreDetail="technicalDetails"/>
        </template>
      
    </div>
</template>

<script>
import FightContent from './content/FightContent.vue'
import GradeContent from './content/GradeContent.vue'
import SampleContent from './content/SampleContent.vue'
import SampContentDetail from './content/SampContentDetail.vue'
export default {
  name:'TaekwondoModalContent',
  props:['technicalDetails','actionTrack'],
  components:{FightContent,GradeContent,SampleContent,SampContentDetail},
  data () {
    return {
      isDetail:false
    }
  },
  methods: {
    showData (){
    }
  },
  mounted () {
    this.showData()
  },
  computed: {
    
  },
}
</script>

<style lang="scss" scoped>
.military-content{
    width: 100%;
    padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/military/MilitaryModalContent.vue